<template>
  <div class="customer-cart" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="购物车"></my-header>
    <div v-if="cartList.length > 0" v-for="(item,index) in cartList" class="customer-cart-part-item general-box-shadow">
      <div class="shop-info" @click="toShopDetail(item.shop.id)">{{item.shop.name}}</div>
      <div v-for="cartItem in item.cartList" class="product-info">
        <img @click="toProductDetail(cartItem.product.id,item.shop.id)" class="product-img" :src="cartItem.product.image">
        <div class="product-sku">
          <div class="product-name" @click="toProductDetail(cartItem.product.id,item.shop.id)">{{cartItem.product.name}}</div>
          <div class="sku-item">
            <div>数量：{{cartItem.quantity}}</div>
            <div class="del-shop-cart" @click = "delShopCart(cartItem)">删除</div>
          </div>
          <div class="product-price">¥ <span>{{cartItem.price * cartItem.quantity}}</span></div>
        </div>
      </div>
    </div>
    <div v-if="cartList.length == 0" class="no-msg">
      <img class="icon-cart" src="../../assets/footer/icon-shopping-car-unselected.png">
      <div>购物车空空荡荡~</div>
      <div @click="goShopList">去逛逛吧-></div>
    </div>
    <div v-if="cartList.length > 0" class="customer-cart-footer">
      <div @click="goSettlement" class="settlement-btn">去结算</div>
    </div>
    <div v-if="isDelCart" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelDelCart">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">确定要删除商品吗?</div>
      <div class="agree-btn" @click="confirmDelCart">确定删除</div>
    </div>
    <div v-if="isDelCart" class="general-box-bg"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import customerCartService from '../../service/customer/CustomerCartService'
  import customerAddressService from '../../service/customer/CustomerAddressService'
  import {imgUrl} from "../../config";
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'CustomerCart',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        pageNo:1,
        cartList:[],
        priceAmount:0,
        isSelectedAll:false,
        preDelCartItem:{},
        isDelCart:false,
        cartIds:[],
        isWechatBrowser:this.$verfyBrowserType(),
        isCouldSettle:false
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      session.isLogin().then(flag => {
        if(flag){
          this.customerCart();
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      });
    },
    methods: {
      async customerCart(){
        let {code,msg,data} = await customerCartService.customerCart();
        if(code == '0'){
          console.info(data)
          this.cartList = [];
          for(let cartItem of data){
            this.cartList.push(cartItem);
          }
        }else {
          Toast(msg);
        }
      },
      async delShopCart(cartItem){
        $('#app').css('overflow-y','hidden');
        this.isDelCart = true;
        this.preDelCartItem = cartItem;
      },
      cancelDelCart(){
        $('#app').css('overflow-y','scroll');
        this.isDelCart = false;
        this.preDelCartItem = {};
      },
      async confirmDelCart(){
         let {code,msg} = await customerCartService.delete(this.preDelCartItem.id);
         if(code == '0'){
           Toast(msg);
           this.isDelCart = false;
           this.preDelCartItem = {};
           this.cartList = [];
           this.customerCart();
         }else {
           Toast(msg);
         }
      },
      async goSettlement(){
        let {code,msg,data} = await customerAddressService.getDefault();
        if(code == '0'){
          if(data != null){
              this.$router.push({name: 'Settlement'})
          }else {
            Toast('请先到我的地址管理添加默认地址!');
          }
        }else {
          Toast(msg);
        }
      },
      goShopList(){
        this.$router.push({name: 'ShopList'})
      },
      //跳转店铺详情
      toShopDetail(id){
        this.$router.push({name: 'ShopDetail', query: {shopId:id}})
      },
      toProductDetail(productId,shopId){
         this.$router.push({name: 'ProductDetail', query: {productId,shopId}})
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .customer-cart {
    padding-top: 0.3rem;
    padding-bottom: 0.6rem;
    font-size: 0.33rem;
    .shop-info{
      width: 6.3rem;
      height: 0.89rem;
      line-height: 0.9rem;
      margin: 0 auto 0.3rem auto;
      border-bottom: solid 1px #e0dedc;
      color: #7f7d7c;
    }
    .customer-cart-part-item{
      width: 6.9rem;
      margin: 0 auto 0.3rem;
      padding-bottom: 0.3rem;
      .product-info{
        margin-bottom: 0.35rem;
        display:flex;
        position:relative;
        .product-img{
          width: 2.3rem;
          height: 2.3rem;
          margin-left: 0.3rem;
          border-radius: 0.06rem;
        }
        .product-sku{
          width: 3.8rem;
          padding-left: 0.2rem;
          .product-name{
            height: 0.8rem;
            line-height: 0.4rem;
            margin-bottom: 0.2rem;
            text-align: justify;
            font-size: 0.32rem;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow : hidden;
            word-break: break-all;
          }
          .sku-item{
            display: flex;
            justify-content: space-between;
            width: 3.8rem;
            font-size: 0.28rem;
            color: #7f7d7c;
            .del-shop-cart{
              width: 0.8rem;
              height: 0.4rem;
              background-color: #fff7e5;
              border-radius: 0.2rem;
              font-size: 0.24rem;
              line-height: 0.42rem;
              text-align: center;
              color: #feac00;
            }
          }
          .product-price{
            margin-top: 0.4rem;
            font-size: 0.32rem;
            font-weight: bold;
            color: #d54a33;
            span{
              font-size: 0.4rem;
            }
          }
        }
      }
    }
    .customer-cart-footer{
      position: fixed;
      display: flex;
      justify-content: flex-end;
      height: 0.7rem;
      line-height: 0.73rem;
      width: 100%;
      bottom: 1.3rem;
      .settlement-btn{
        width: 1.9rem;
        margin-right: 0.34rem;
        border-radius: 0.7rem;
        text-align: center;
        color: white;
        background-color: #feac00;
      }
    }
  }
</style>
